<app-page-shell variant="default" [embedded]="isModal()">
<!-- Add User Section  Start -->
    <app-sb-input-form
      [mode]="clientId() ? 'edit' : 'add'"
      [title]="(clientId() ? 'Update' : 'Add') + ' client'"
      submitLabel="Save"
      [stickyFooter]="!isModal()"
      [embedded]="isModal()"
      (submitted)="saveClient()"
      (cancelled)="cancelClick()">
        <div class="form-wraper" [formGroup]="addClientForm">
            <!-- Add User form column start -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 text-center d-flex justify-content-center align-items-center">
                <app-sb-input-image
                  formControlName="logo"
                  label="Logo"
                  [autoUpload]="true"
                  [clientId]="clientId()"
                  [showFileBrowser]="false"
                  accept="jpg,jpeg,png,webp"
                  [minWidth]="150"
                  [minHeight]="150"
                  [maxWidth]="2048"
                  [maxHeight]="2048"
                  [maxFileSize]="5242880">
                </app-sb-input-image>
              </div>
              <div class="col-md-8 col-md-8 col-sm-12">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-ms-12" [class.col-lg-12]="clientId() !== null" [class.col-md-6]="clientId() !== null" [class.col-ms-12]="clientId() !== null">
                    <div class="floating-label">
                      <input [class.is-invalid]="submitted() && f.name.errors"
                             formControlName="name" id="name" placeholder=" "
                             required="required" class="floating-input"
                             type="text"/>
                      <label for="name">Name <span class="red">*</span>
                      </label>
                      @if (submitted() && f.name.errors) {
                      <div class="bar error-brd">
                        @if (f.name.errors.required) {
                        <div class="invalid-text">Name is required</div>
                        }
                      </div>
                      }

                    </div>
                  </div>
                  @if (!clientId()) {
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input [class.is-invalid]="submitted() && f.password.errors"
                             formControlName="password" id="password" placeholder=" "
                             required="required" class="floating-input"
                             type="text"/>
                      <label for="password">Password <span class="red">*</span>
                      </label>
                      @if (submitted() && f.password.errors) {
                      <div class="bar error-brd">
                        @if (f.password.errors.required) {
                        <div class="invalid-text">Password is required</div>
                        }
                      </div>
                      }
                      <button type="button" class="btn btn-default btn-sm p-0" title="Generate Password"
                              (click)="generateRandomPassword()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                  }
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label">
                      <input [class.is-invalid]="submitted() && f.email.errors"
                             formControlName="email" id="email" class="floating-input"
                             required="required" placeholder=" "
                             type="text"/>
                      <label for="email">Email <span class="red">*</span>
                      </label>
                      @if (submitted() && f.email.errors) {
                      <div class="bar error-brd">
                        @if (f.email.errors.required) {
                        <div class="invalid-text">Email is required</div>
                        }
                        @if (f.email.errors.email) {
                        <div class="invalid-text">Enter valid email address</div>
                        }
                      </div>
                      }
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12 py-2">
                    <div class="floating-label">
                      <input [class.is-invalid]="submitted() && f.website.errors"
                             formControlName="website" id="website" class="floating-input"
                             placeholder=" "
                             type="text"/>
                      <label for="website">Website <span class="red">*</span>
                      </label>
                      @if (submitted() && f.website.errors) {
                      <div class="bar error-brd">
                        @if (f.website.errors.pattern) {
                        <div class="invalid-text">Enter valid URL</div>
                        }
                        @if (f.website.errors.required) {
                        <div class="invalid-text">Website is required</div>
                        }
                      </div>
                      }
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label">
                      <app-creatable-select
                        id="organization"
                        [selectedValue]="f.organization_id.value"
                        [hideLabel]="true" [onlyBottomBorder]="true" [isCreatable]="false"
                        [placeholder]="'Organization'" [selectOptions]="organizations()"
                        (optionSelected)="organizationSelected($event)"></app-creatable-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label">
                      <app-creatable-select
                        id="package"
                        [selectedValue]="f.package_id.value"
                        [hideLabel]="true" [onlyBottomBorder]="true" [isCreatable]="false"
                        [placeholder]="'Select a Package'" [selectOptions]="packages()"
                        (optionSelected)="packageSelected($event)"></app-creatable-select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-ms-12 mb-3">
                        <app-sb-input-time type="date" valueAs="date" label="Package Start Date" [min]="min"
                          formControlName="package_start_date"></app-sb-input-time>
                      </div>
                      <div class="col-lg-6 col-md-6 col-ms-12 mb-3">
                        <app-sb-input-time type="date" valueAs="date" label="Package End Date" [min]="max"
                          formControlName="package_end_date"></app-sb-input-time>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="floating-label flex-wrap info-input">
                      <input formControlName="login_whitelisted_ips" id="login_whitelisted_ips" placeholder=" " class="floating-input" type="text"/>
                      <label for="login_whitelisted_ips">White Listed Ips</label>
                      <app-info-popover
                        info="i.e. IP1,IP2,IP3,IP4, ...">
                      </app-info-popover>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-md-12 my-1">
                    <div class="action-check-box align-items-center">
                      <input formControlName="require_google_utm_for_cta_links" id="require_google_utm_for_cta_links" type="checkbox" class="styled-checkbox" >
                      <label for="require_google_utm_for_cta_links" class="ms-2">Require Google UTM for CTA links</label>
                      <app-info-popover
                        info="It will automatically add a UTM link to your CTA links.">
                      </app-info-popover>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="floating-label flex-wrap info-input">
                      <input [class.is-invalid]="submitted() && f.google_utm_params.errors"
                             formControlName="google_utm_params" id="google_utm_params" placeholder=" " class="floating-input" type="text"/>
                      <label for="google_utm_params">Google UTM Params</label>
                      @if (submitted() && f.google_utm_params.errors?.utmParams) {
                      <div class="bar error-brd">
                        <div class="invalid-text">{{ f.google_utm_params.errors.utmParams }}</div>
                      </div>
                      }
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="floating-label">
                  <textarea [class.is-invalid]="submitted() && f.comment.errors"
                            class="floating-input"
                            formControlName="comment" id="comment" style="height: 150px"></textarea>
                      <span class="highlight"></span>
                      <label>Comment</label>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12">
                    <div class="font-size-lg mb-2">Settings</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="floating-label">
                      <select class="floating-input" formControlName="widget_version" id="client_widget_version">
                        <option [ngValue]="null">Default (global setting)</option>
                        <option value="v1">v1 - Current (stable)</option>
                        <option value="v2">v2 - Latest (beta)</option>
                      </select>
                      <span class="highlight"></span>
                      <label for="client_widget_version">Widget Version</label>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="floating-label">
                      <select class="floating-input" formControlName="widget_cdn_enabled" id="client_widget_cdn_enabled">
                        <option [ngValue]="null">Default (global setting)</option>
                        <option [ngValue]="true">Enabled</option>
                        <option [ngValue]="false">Disabled</option>
                      </select>
                      <span class="highlight"></span>
                      <label for="client_widget_cdn_enabled">Activate CDN for Widget</label>
                    </div>
                  </div>
                </div>


              </div>
            </div>
        </div>
        <ng-template sbInputFormActions>
          <div class="sb-form__footer-actions">
            <app-sb-button variant="default" label="Cancel" icon="fa fa-times" type="button" (clicked)="cancelClick()"></app-sb-button>
            @if (currentUser()?.can('create', 'client')) {
            <app-sb-button variant="primary" label="Save" icon="fa fa-check" type="submit"></app-sb-button>
            }
          </div>
        </ng-template>
    </app-sb-input-form>
</app-page-shell>
